import callApi from './callApi';

export const bulkUpdateTestcases = (data) => {
    const url = `testcases/bulk-update`;
    return callApi(url, {}, 'PUT', data);
  };